// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1t7n0","filesListContainer":"PosDisputesFiles_filesListContainer__31Ykb","filesButton":"PosDisputesFiles_filesButton__1awOL"};